var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-method text-center"},[(_vm.imageSrc)?_c('img',{attrs:{"src":_vm.imageSrc,"alt":_vm.altText,"height":"20"}}):_vm._e(),_c('div',{staticClass:"mt-1"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }